module.exports = __webpack_public_path__ + "img/08-MobileGames-01.5b0f9cc1.png";